import React from 'react';
import { useTranslation } from 'react-i18next';

import HeaderCard from '../../components/Header/HeaderCard';
import ListeDossiersDisciplinaires from './ListeDossiersDisciplinaires';

/**
 * Le registre des dossiers disciplinaires (contrat C39, Yros/Kavero#15),
 * réservé à la RH avec l'offre RH (`canGererDossiersDisciplinaires`).
 */
function DossiersDisciplinaires() {
  const { t } = useTranslation();
  return (
    <div className="p-4 space-y-4">
      <HeaderCard title={t('discipline.titre')} text={t('discipline.description')} />
      <ListeDossiersDisciplinaires />
    </div>
  );
}

export default DossiersDisciplinaires;
